import { put, select, takeLatest } from "redux-saga/effects";
import { Notify } from "../../../UIcomponent/NotificationManager";
import DashboardReq from "../../../Utility/Requester/DashboardReq";
import actions from "../../actions";

const getModalData = (state) => state.dashboard.suspendModal.data;

export default function* suspend() {
  yield takeLatest(
    actions.dashboard.suspend.SUSPEND_CLASS_REQUEST,
    function* () {
      try {
        let { id, suspended_by } = yield select(getModalData);
        let body = {
          SuspendedBy: suspended_by,
        };
        yield DashboardReq.suspendClassByTeacher(id, body);

        yield put(actions.dashboard.sessions.suspendSession(id));
        yield put({
          type: actions.dashboard.suspend.SUSPEND_CLASS_SUCCESS,
        });
        yield put(actions.dashboard.suspendModal.reset());

        yield Notify("success", "تعلق با موفقیت انجام شد.");
      } catch (error) {
        yield Notify("error", error.response.data.message);
        yield put({
          type: actions.dashboard.suspend.SUSPEND_CLASS_ERROR,
        });
      }
    }
  );
}
